import { setTrackingConsent, useTrackingConsent } from '@/analytics/consent';

export function TrackingConsentBanner() {
  const consent = useTrackingConsent();

  if (consent) return null;

  return (
    <aside
      role="dialog"
      aria-label="Optional analytics consent"
      className="pointer-events-none fixed inset-x-4 bottom-4 z-50 mx-auto max-w-3xl rounded-2xl border border-border bg-background p-4 shadow-2xl sm:inset-x-auto sm:right-6 sm:w-[min(100%-3rem,42rem)]"
    >
      <p className="text-sm leading-6 text-muted-foreground">
        Optional analytics and campaign measurement help us improve Day Sheetly.
        Essential product functionality works without them. See the Privacy
        Policy on daysheetly.com for details.
      </p>
      <div className="mt-3 flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
        <button
          type="button"
          className="pointer-events-auto rounded-lg border border-border px-4 py-2 text-sm font-medium text-foreground transition-colors hover:bg-muted"
          onClick={() => setTrackingConsent('denied')}
        >
          Reject optional
        </button>
        <button
          type="button"
          className="pointer-events-auto rounded-lg bg-primary px-4 py-2 text-sm font-semibold text-primary-foreground transition-colors hover:bg-primary-hover"
          onClick={() => setTrackingConsent('granted')}
        >
          Accept analytics
        </button>
      </div>
    </aside>
  );
}
